/* src/app/order/components/estimate-questions/long-option-single-choice/long-option-single-choice.style.scss */
.question-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  font-size: 0.938rem;
}
.additional-question-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #585858;
  margin-bottom: 10px;
}
.vertical {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.horizontal {
  display: flex;
  flex-direction: row;
}
.form-row-container {
  flex-wrap: nowrap;
  width: 100%;
  margin-bottom: 20px;
}
.form-row-container .form-input {
  width: 100%;
}
.form-row-container .form-input:nth-child(2) {
  margin-left: 30px;
}
.question-options .question-option {
  cursor: pointer;
  padding: 26px 20px 20px 20px;
  border: solid 1px #cccccc;
  width: 100%;
}
.question-options .question-option.with-margin {
  margin-right: 31px;
}
.question-options .question-option.selected {
  border: solid 1px #007d40;
  color: #007d40;
  font-weight: bold;
  background-color: #e5faee;
}
.question-options .question-option:hover {
  background-color: #e5faee;
}
.question-options .question-option.invalid {
  border: solid 1px red;
  background-color: #fff0f2;
}
.question-options .question-option.disabled {
  background-color: #f2f2f2;
}
.question-options .question-option .more {
  font-weight: bold;
  font-size: 0.75rem;
  color: #007d40;
  line-height: 1.33;
  margin-top: 13px;
}
.question-options .question-option .more nb-icon {
  vertical-align: middle;
}
.radio-button-row .radio-button-group {
  margin-right: 30px;
  width: 140px;
  min-width: 140px;
}
.radio-button-row div:first-child {
  padding-right: 0;
}
.radio-button-row div:last-child {
  padding-left: 0;
}
.radio-button-row .attached-question-name {
  font-size: 15px;
  line-height: 1.47;
  color: #585858 !important;
  margin-top: auto;
  margin-bottom: auto;
}
.radio-button-row nb-radio-group {
  display: flex;
}
.attached-question-description {
  margin: 10px 0 0 0;
  max-width: 100%;
  max-height: 200px;
}
@media screen and (max-width: 991px) {
  .attached-question .form-input.radio-button-group {
    margin: 0;
  }
}
@media screen and (max-width: 767px) {
  .question-options {
    display: flex;
    flex-direction: column;
  }
  .question-options .question-option {
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
  .form-row-estimates {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }
  .form-row-estimates .form-input {
    width: 100%;
  }
  .form-row-estimates .form-input:nth-child(2) {
    margin-left: 30px;
  }
  .question-label {
    font-family: Arial, sans-serif;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.33;
    color: #007d40;
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
  }
  .radio-button-row {
    flex-wrap: wrap;
  }
  .attached-question {
    display: flex;
    flex-direction: column-reverse;
    margin: 0;
  }
  .attached-question-description {
    margin: 0;
    max-width: 100%;
    max-height: 200px;
  }
  .radio-button-row .radio-button-group {
    margin: 0;
  }
}
/*# sourceMappingURL=long-option-single-choice.style.css.map */
